import type { ComponentProps } from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { tv } from "tailwind-variants";

import { icons } from "@/ui/icons";
import { focusRing } from "./interaction";

const checkboxVariants = tv({
  slots: {
    root: [
      "peer size-5 shrink-0 cursor-pointer rounded-md border border-line-strong bg-surface shadow-xs",
      "transition-colors hover:border-focus",
      focusRing,
      "disabled:cursor-not-allowed disabled:border-line disabled:bg-surface-muted",
      "data-[state=checked]:border-surface-inverted data-[state=checked]:bg-surface-inverted data-[state=checked]:text-content-on-inverted",
      "data-[state=checked]:disabled:border-line data-[state=checked]:disabled:bg-surface-muted data-[state=checked]:disabled:text-content-subtle",
    ],
    indicator: "flex items-center justify-center text-current transition-none",
    icon: "size-3.5 stroke-3",
  },
});

const { icon, indicator, root } = checkboxVariants();

type CheckboxProps = ComponentProps<typeof CheckboxPrimitive.Root>;

export const Checkbox = ({ className, ...props }: CheckboxProps) => {
  return (
    <CheckboxPrimitive.Root className={root({ className })} data-slot="checkbox" {...props}>
      <CheckboxPrimitive.Indicator className={indicator()} data-slot="checkbox-indicator">
        <icons.CheckIcon className={icon()} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};
